module.exports = __webpack_public_path__ + "img/2.6fe31496.png";